import { DisableHelpOverrides, Environment, WebsitePortalAuthenticationOverrides } from '@sb/library/base';
import { BrandEnvironment as TestBase } from '@shared-environments/Test443/brand.environment';
import { BrandProductName, BrandTestURLOverrides } from './brand.environment';
import { BuildVersion } from './build-version';

export const environment = new Environment({
    ...TestBase,
    ...WebsitePortalAuthenticationOverrides,
    ...DisableHelpOverrides,
    ...BuildVersion,
    Application: {
        ...TestBase.Application,
        ...BrandTestURLOverrides,
        ProductName: BrandProductName,
    }
});
